/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'academypayment';
@Injectable(
  {
    providedIn: "root"
  }
)
export class AcademypaymentService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }
  getAcademyPaymentList(query): Observable<any> {
    return this.http.get<any>(API_URL + query, this.httpOptions);
  }
  getAcademyPaymentListwithoutAuth(query) {
    return this.http.get<any>(API_URL+"/v1/"+query);
}
  //   getAcademyDetails(id: string) {
  //     return this.http.get<any>(`${API_URL}/${id}`, this.httpOptions);
  //   }
  verfiyAcademypayment(academypayment) {
    return this.http.post<any>(API_URL + '/verify', academypayment, this.httpOptions);
  }
  //   updateAcademy(id: string, academy): Observable<any> {
  //     return this.http.put(API_URL + '/' + id, academy, this.httpOptions);
  //   }

  addAcademyPayment(data): Observable<any> {
    return this.http.post(API_URL, data, this.httpOptions);
  }

  updateAcademyPayment(id, data): Observable<any> {
    return this.http.put(API_URL + '/' + id, data, this.httpOptions);
  }

  sendAcademyPaymentInvoice(id, data): Observable<any> {
    return this.http.put(environment.apiUrl + 'academy/regenerate/' + id, data, this.httpOptions);
  }
}
